import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SortableTable } from "../../components/SortableTable/SortableTable";
import {
  applyFiltersToArray,
  convertDateFormat,
  getGlobalHyperLinkColor,
  formatMidasNumber
} from "../../global";
import ProcessMenuItem from "./ProcessMenuItem";
import ModalSimpleButton from "../../components/Modal/ModalSimpleButton";
import { Divider } from "@mui/material";

const LinkTo = styled(Link)({
  textAlign: "left",
  fontFamily: "EMprint",
  fontWeight: "600",
  textTransform: "none",
  color: getGlobalHyperLinkColor(),
  textDecoration: "underline",
  cursor: "pointer",
});

const TableRequestQueue = ({
  filters,
  myRequests,
  reloadSpecialAnalysis,
  isDataLoading,
  billingList,
  isProcessing,
  copySpecialAnalysis,
}) => {
  const [filteredRequests, setFilteredRequests] = useState([]);

  const MySortableSpecialAnalysisCols = [
    {
      id: "id",
      label: "ID",
      transform: (value) => (
        <LinkTo to={{ pathname: `/viewSpecialAnalysis/${value}`, state: { tab: 'process' } }}>{value}</LinkTo>
      )
    },
    {
      id: "comments",
      label: "Comments",
      transform: (value) => (
        value?.split("|")
            ?.filter(
              (val) =>
                !val?.includes(":  Old value: '") &&
                val?.length > 0 &&
                val?.split("):")[1]?.length > 0,
            )
            ?.slice(-2)
            ?.map((val, index, arr) => (
              <React.Fragment key={index}>
                <div>{val}</div>
                { index < arr.length -1 && (
                  <Divider sx={{ width: "100%", margin: "6px 0"}}/>
                  )
                }
              </React.Fragment>
              ))
      )
    },
    {
      id: "priorityName",
      label: "Priority",
    },

    {
      id: "description",
      label: "Description",
    },
    {
      id: "specialAnalysisSamples",
      label: "MIDAS #",
      transform: (value) => ( value.map(p => formatMidasNumber(p.sampleName)).join(", "))
    },
    {
      id: "requestedByEmail",
      label: "Requester",
    },
    {
      id: "assignedToEmail",
      label: "Assigned To",
    },
    {
      id: "requestedCompletionDate",
      label: "Requested Completion",
      transform: (value) => {
        return value ? convertDateFormat(value, false) : "";
      },
    },
    {
      id: "lastAcceptableCompletionDate",
      label: "Last Acceptable Date",
      transform: (value) => (value ? convertDateFormat(value, false) : ""),
    },
    {
      id: "businessUnitName",
      label: "Business Unit",
    },
    {
      id: "statusName",
      label: "Status",
    }];

  useEffect(() => {
    var filteredArray = applyFiltersToArray(filters, myRequests);
    setFilteredRequests(filteredArray);
  }, [filters, myRequests]);

  const [modalMessagesOpen, setModalMessagesOpen] = useState(false);
  const [modalMessagesText, setModalMessagesText] = useState("");
  const [modalMessagesTitle, setModalMessagesTitle] = useState("");
  const [modalMessagesButtonText, setModalMessagesButtonText] = useState("Ok");

  function closeModalMessages() {
    setModalMessagesOpen(false);
    setModalMessagesText("");
    setModalMessagesButtonText("");
    setModalMessagesTitle("");
  }

  return (
    <div style={{ width: "100%" }}>
      <SortableTable
        columns={MySortableSpecialAnalysisCols.filter(f => (!isProcessing && f.label !== 'Business Unit') || isProcessing)}
        count={filteredRequests.length ?? 0}
        loading={isDataLoading}
        rows={filteredRequests}
        rowsPerPage={10}
        initialOrderBy={"priorityName"}
        children={<ProcessMenuItem myRequests={myRequests} billingList={billingList} reloadSpecialAnalysis={reloadSpecialAnalysis} copySpecialAnalysis={copySpecialAnalysis} />}
        tableSize="small"
      ></SortableTable>

      <ModalSimpleButton
        title={modalMessagesTitle}
        buttonText={modalMessagesButtonText}
        buttonAction={closeModalMessages}
        open={modalMessagesOpen}
        setOpen={setModalMessagesOpen}
      >
        <div dangerouslySetInnerHTML={{ __html: modalMessagesText }} />
        <label>
        </label>
      </ModalSimpleButton >
    </div >
  );
};

export default TableRequestQueue;
